import React from 'react';

interface HeaderBannerProps {
  className?: string;
}

const HeaderBanner: React.FC<HeaderBannerProps> = ({ className = "" }) => {
  return (
    <div className={`w-full h-16 md:h-20 lg:h-24 bg-gradient-to-r from-primary-500 via-secondary-500 to-accent-1 flex items-center justify-center text-white shadow-lg ${className}`}>
      <div className="text-center">
        <div className="text-lg md:text-xl lg:text-2xl font-bold tracking-wide">
          NORTH LAKES FOOD BANK
        </div>
        <div className="text-xs md:text-sm lg:text-base opacity-90 mt-1">
          Community Food Security & Sustainability
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner; 